import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormIndividualizedTransitionPlan } from "../Models/Forms/IFormIndividualizedTransitionPlan";

@Injectable()
export class FormIndividualizedTransitionPlanService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormIndividualizedTransitionPlan(id: number) {
    return this._http.get(this._baseUrl + "api/FormIndividualizedTransitionPlan/" + id)
      .map((response: IFormIndividualizedTransitionPlan) => response as IFormIndividualizedTransitionPlan)
      .catch(this.errorHandler);
  }

  getCreditsToDate(iepInstanceId: number) {
    return this._http.get(this._baseUrl + "api/FormIndividualizedTransitionPlan/GetCreditsToDate/" + iepInstanceId.toString())
      .map((response: number) => response as number)
      .catch(this.errorHandler);
  }

  insertUpdateFormIndividualizedTransitionPlan(formIndividualizedTransitionPlanDetails: IFormIndividualizedTransitionPlan) {
    return this._http.post(this._baseUrl + 'api/FormIndividualizedTransitionPlan', formIndividualizedTransitionPlanDetails)
      .map((response: IFormIndividualizedTransitionPlan) => response as IFormIndividualizedTransitionPlan)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormIndividualizedTransitionPlan/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteIndividualizedTransitionPlan(id) {
    return this._http.delete(this._baseUrl + "api/FormIndividualizedTransitionPlan" + id)
      .map((response: IFormIndividualizedTransitionPlan) => response as IFormIndividualizedTransitionPlan)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}




